<template>
<div>
  <HideableDiv v-bind:changing-button="true">
    <template slot="buttonVisible">
      <button style="float: right" >Hide help</button>
    </template>
    <br>
    <template slot="buttonHidden">
      <button style="float: right" >Show help</button>
    </template>
    <p class="text-align-left">
      The list above shows all missions in this Campaign. Each entry shows the date on which the mission was flown, its
      name, and the historical date on which the events outlined in each mission took place.
    </p>
    <p>Missions are set to one of three statuses.</p>
    <ul>
      <li><b>Briefing:</b> During the Briefing phase of a mission, only the briefing of your faction will be available to you and After Action Reports cannot be created or edited.</li>
      <li><b>Debriefing:</b> During the Debriefing phase, only the briefings of your faction are visible to you. This is the phase directly after a mission has been flown, during which pilots file and can edit their After Action Reports.</li>
      <li><b>Closed:</b> Once the debriefing period has been completed and all After Action Reports have been filed and accepted, the mission briefings become public. Once more, After Action Reports cannot be created or edited.</li>
    </ul>
    <p class="text-align-left">
      To see a mission's briefings or After Action Reports, click on any mission from the list below.
      To file or edit a report, enter the mission you wish to file a report for.
    </p>
  </HideableDiv>
  <br>
</div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import CampaignInfoBaseComp from "./CampaignInfoBaseComp";
import HideableDiv from "../basic_comp/HideableDiv";

export default {
  name: 'CampaignInfoHelp',
  components: {CampaignInfoBaseComp, HideableDiv},
  mounted () {

    this.$store.dispatch('missionStore/loadStoreData',
      {
        caller: this.$options.name,
        call_object: {
          view: "campaign_list",
          id: this.$route.params.campaign_id
        },
        data_array_name: "campaign"
      }
    ).catch(error => {
      console.log(error.message);
    });
  },
  computed: {

    ...mapState("missionStore", {

      campaign: state => state.campaign,
    }),
  },
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignInfoHelp.vue